import React from 'react';
import PropTypes from 'prop-types';

class Dates extends React.Component {
    static propTypes = {
        month_name: PropTypes.string.isRequired,
        days_list: PropTypes.instanceOf(Array).isRequired,
        selectedDate: PropTypes.number.isRequired,
        onDateSelect: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            mobile: window.innerWidth <= 760
        };
        this.slick = null;
        this.slickRef = null;
    }


    render() {
        const days = this.props.days_list.map(item => (
            <button
                onClick={() => this.props.onDateSelect(item.day)}
                key={`dates_index_${item.day}`}
                className={item.day === this.props.selectedDate ? `active ${this.state.mobile ? 'swiper-slide' : ''}` : `${this.state.mobile ? 'swiper-slide' : ''}`}
            >
                <span>{item.day}</span>
                <span>{item.name}</span>
            </button>));
        return (
            <div className="calendar__dates">
                <div className="dates__title">{this.props.month_name}</div>
                <div className="dates__list">{days}</div>
            </div>
        );
    }
}


export default Dates;



// WEBPACK FOOTER //
// ./src/components/Calendar/Dates.jsx